import { render, staticRenderFns } from "./ACT.vue?vue&type=template&id=b8b2fb00&scoped=true&"
import script from "./ACT.vue?vue&type=script&lang=js&"
export * from "./ACT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b2fb00",
  null
  
)

export default component.exports